import { useConfirm, useDirtyGuard } from '@hprofits/ui';
import type { Ref } from 'vue';
import { onScopeDispose } from 'vue';
import { useRouter } from 'vue-router';

import { t } from '@/i18n';

export const useBlacklistDirtyGuard = (isDirty: Readonly<Ref<boolean>>): void => {
  const router = useRouter();
  const confirm = useConfirm();
  useDirtyGuard({ isDirty }, { scope: 'beforeunload' });
  // The UI bundle embeds its own router injection key. Register with the application's router
  // so navigation protection works for consumers of the built package as well as source.
  const unregister = router.beforeEach(() =>
    isDirty.value
      ? confirm({
          title: t('modules.blacklistAutoRules.editor.unsaved'),
          description: t('modules.blacklistAutoRules.editor.leaveHint'),
          confirmText: t('modules.blacklistAutoRules.editor.leave'),
        })
      : true,
  );
  onScopeDispose(unregister);
};
